import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePublicList } from '../hooks/usePublicList';
import { buildImageUrl } from '../api/client';

export default function Doctors() {
  const navigate = useNavigate();
  const { data: doctors, loading } = usePublicList('doctors');
  const sorted = [...doctors].sort((a, b) => a.order - b.order);
  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title">Həkimlər</h2>
        <p className="section-subtitle">Mütəxəssis komandamız</p>
        {loading ? <p style={{ textAlign: 'center', color: '#6b7280' }}>Yüklənir...</p> : (
          <div className="grid-4">
            {sorted.map((d) => (
              <div key={d.id} className="dcard" onClick={() => navigate(`/hekimler/${d.id}`)}>
                <h5>{d.name}</h5>
                <p>{d.specialty}</p>
                <div className="thumb"><img src={buildImageUrl(d.image)} alt={d.name} /></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
